import { type AggDesignOptionDto } from "src/types/AggDesignOptionDto";
import { Decompress } from "./Decompress";

export function DecompressAggDesignDto(compressedSite: Uint8Array): AggDesignOptionDto {
  return Decompress(compressedSite);
}
